class HomepageHero extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this._animateContent();

    if (!this.querySelector('[data-hero-pill]')) return;
    this._playPillVideo();
    this._setupModal();
  }

  _animateContent() {
    var words = this.querySelectorAll('[data-hero-word]');
    var desc = this.querySelector('[data-hero-desc]');
    var cta = this.querySelector('[data-hero-cta]');
    if (!words.length) return;

    var stagger = 60;
    var wordDuration = 210;
    var len = words.length;

    words.forEach(function (word, i) {
      var blur = Math.min((i + 1) * 1.5, 10);
      var anim = word.animate(
        [
          { opacity: 0, filter: 'blur(' + blur + 'px)', transform: 'translateY(6px)' },
          { opacity: 1, filter: 'blur(0px)', transform: 'translateY(0)' }
        ],
        { duration: wordDuration, delay: i * stagger, easing: 'ease-out', fill: 'forwards' }
      );
      anim.onfinish = function () {
        word.style.opacity = '1';
        word.style.filter = 'none';
        word.style.transform = 'none';
        anim.cancel();
      };
    });

    var headlineDone = (len - 1) * stagger + wordDuration;

    if (desc) {
      desc.animate(
        [
          { opacity: 0, transform: 'translateY(8px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        { duration: 200, delay: headlineDone + 80, easing: 'ease-out', fill: 'forwards' }
      );
    }

    if (cta) {
      cta.animate(
        [
          { opacity: 0, transform: 'translateY(8px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        { duration: 200, delay: headlineDone + 200, easing: 'ease-out', fill: 'forwards' }
      );
    }
  }

  _playPillVideo() {
    var pill = this.querySelector('[data-hero-pill] video');
    if (!pill) return;
    pill.play().catch(function () {});
  }

  _setupModal() {
    var self = this;
    var modal = this.querySelector('[data-hero-modal]');
    document.body.appendChild(modal);
    this._modal = modal;

    var backdrop = modal.querySelector('[data-modal-backdrop]');
    var closeBtn = modal.querySelector('[data-modal-close]');
    var video = modal.querySelector('[data-hero-video]');

    this.querySelector('[data-hero-pill]').addEventListener('click', function () {
      self._openModal();
    });

    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) self._closeModal();
    });

    closeBtn.addEventListener('click', function () {
      self._closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
        self._closeModal();
      }
    });

    this._preloadWhenIdle(video);
  }

  _preloadWhenIdle(video) {
    if (!video) return;
    var preload = function () {
      video.preload = 'auto';
      video.load();
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(preload, { timeout: 3000 });
    } else {
      setTimeout(preload, 2000);
    }
  }

  _openModal() {
    var modal = this._modal;
    var card = modal.querySelector('[data-modal-card]');
    var video = modal.querySelector('[data-hero-video]');

    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';

    modal.animate(
      [{ opacity: 0 }, { opacity: 1 }],
      { duration: 250, easing: 'ease-out', fill: 'forwards' }
    );
    card.animate(
      [
        { opacity: 0, transform: 'scale(0.95) translateY(20px)' },
        { opacity: 1, transform: 'scale(1) translateY(0)' }
      ],
      { duration: 300, easing: 'ease-out', fill: 'forwards' }
    );

    video.play().catch(function () {});
  }

  _closeModal() {
    var modal = this._modal;
    var card = modal.querySelector('[data-modal-card]');
    var video = modal.querySelector('[data-hero-video]');

    video.pause();

    var backdropAnim = modal.animate(
      [{ opacity: 1 }, { opacity: 0 }],
      { duration: 200, easing: 'ease-in', fill: 'forwards' }
    );
    card.animate(
      [
        { opacity: 1, transform: 'scale(1) translateY(0)' },
        { opacity: 0, transform: 'scale(0.95) translateY(20px)' }
      ],
      { duration: 200, easing: 'ease-in', fill: 'forwards' }
    );

    backdropAnim.onfinish = function () {
      modal.classList.add('hidden');
      document.body.style.overflow = '';
    };
  }
}

customElements.define('homepage-hero', HomepageHero);
